import { useBreakpointValue } from '@chakra-ui/react';

import { commonUiStateSlice, useAppSelector } from '@app/app-state';

export const useAppHeaderHook = (): {
    isMobileRes: boolean | undefined;
    isMobileBrowser: boolean;
} => {
    const isMobileBrowser = useAppSelector(commonUiStateSlice.selectors.selectIsMobileVersion);
    const isMobileResBreakpoint = useBreakpointValue(
        {
            base: true,
            lg: false,
        },
        {
            fallback: isMobileBrowser ? 'base' : 'lg',
        },
    );
    const isMobileRes = isMobileResBreakpoint ?? isMobileBrowser;

    return {
        isMobileRes,
        isMobileBrowser,
    };
};
